import { render, staticRenderFns } from "./image-preview.vue?vue&type=template&id=0293b488&scoped=true"
import script from "./image-preview.vue?vue&type=script&lang=ts"
export * from "./image-preview.vue?vue&type=script&lang=ts"
import style0 from "./image-preview.vue?vue&type=style&index=0&id=0293b488&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0293b488",
  null
  
)

export default component.exports